/**
 * @generated SignedSource<<b52efab25740168d17c4986ccafe7f97>>
 * @relayHash 0b37d3947d2ba6796382543ab8414925
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 32f0eb83348c8b9f3108dbc0de5e6f0e7b1655cb0d341311b5182d0810e949af

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateMyActivityInput = {
  clientMutationId?: string | null | undefined;
  timeZone?: string | null | undefined;
};
export type ProviderUpdateMyActivityMutation$variables = {
  input: UpdateMyActivityInput;
};
export type ProviderUpdateMyActivityMutation$data = {
  readonly updateMyActivity: {
    readonly user: {
      readonly id: string;
      readonly userActivity: {
        readonly lastActiveAt: string;
        readonly timeZone: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ProviderUpdateMyActivityMutation = {
  response: ProviderUpdateMyActivityMutation$data;
  variables: ProviderUpdateMyActivityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastActiveAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProviderUpdateMyActivityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateMyActivityPayload",
        "kind": "LinkedField",
        "name": "updateMyActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActivity",
                "kind": "LinkedField",
                "name": "userActivity",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProviderUpdateMyActivityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateMyActivityPayload",
        "kind": "LinkedField",
        "name": "updateMyActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActivity",
                "kind": "LinkedField",
                "name": "userActivity",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "32f0eb83348c8b9f3108dbc0de5e6f0e7b1655cb0d341311b5182d0810e949af",
    "metadata": {},
    "name": "ProviderUpdateMyActivityMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b391b0986b786833f455a4fc19ce37c5";

export default node;
